import type { OrderLineItemSchema, OrderResponseSchema } from '@lyka-pet-food/contracts';
import { AddressState, DeliverySlotWindow } from '@lyka-pet-food/contracts'
import { z } from 'zod'

export type Order = z.infer<typeof OrderResponseSchema>
export type OrderLineItem = z.infer<typeof OrderLineItemSchema>

export const OrderDisplayType = {
  HIDDEN: 'HIDDEN',
  FAILED: 'FAILED',
  PAST: 'PAST',
  CURRENT_PREPARING: 'PREPARING',
  CURRENT_ON_ITS_WAY: 'ON ITS WAY',
  CURRENT_DELIVERED: 'DELIVERED',
  FUTURE: 'FUTURE',
  NEXT_AVAILABLE: 'NEXT AVAILABLE',
} as const
export type OrderDisplayType = (typeof OrderDisplayType)[keyof typeof OrderDisplayType]

export interface OrderFeedingPlan {
  animalId: string
  planType: string
  skus: OrderLineItem[]
}

export type EnrichedOrder = Order & {
  displayType: OrderDisplayType
  feedingPlans: OrderFeedingPlan[]
  extras: OrderLineItem[]
  chargedAmount: number
  isMultiTreatDiscountApplied: boolean
}

export const UpdateOrderDeliveryInfoSchema = z.object({
  applyToFutureOrders: z.boolean().optional(),
  postcode: z.string(),
  suburb: z.string(),
  address: z
    .object({
      addressId: z.string(),
      address1: z.string(),
      address2: z.string().optional(),
      city: z.string(),
      countryCode: z.string(),
      state: z.nativeEnum(AddressState),
      companyName: z.string().optional(),
      deliveryInstructions: z.string().optional(),
    })
    .optional(),
  date: z
    .object({
      deliveryDate: z
        .string()
        .refine((val) => /^\d{4}-\d{2}-\d{2}$/.test(val), { message: 'deliveryDate must be in YYYY-MM-DD format' }),
      deliverySlotId: z.nativeEnum(DeliverySlotWindow),
    })
    .optional(),
  deliveryContactNumber: z.string().optional().nullable(),
})

export type UpdateOrderDeliveryInfo = z.infer<typeof UpdateOrderDeliveryInfoSchema>
